module.exports = __webpack_public_path__ + "img/indicadores-aps.0fe02e63.svg";